import { size } from "polished";
import Typography from "typography";

const typography = new Typography({
  title: "Sondro",
  baseFontSize: "18px",
  baseLineHeight: 1.45,
  includeNormalize: false,
  headerFontFamily: ["Montserrat", "sans-serif"],
  bodyFontFamily: ["Raleway", "sans-serif"],
  scaleRatio: 2.441,
  headerWeight: 700,
  googleFonts: [
    {
      name: "Montserrat",
      styles: ["700", "400"],
    },
    {
      name: "Raleway",
      styles: ["400"],
    },
  ],
  overrideStyles: () => ({
    img: {
      marginBottom: 0,
    },
  }),
});

/*
const typography = new Typography({
  title: "Sondro",
  baseFontSize: "18px",
  baseLineHeight: 1.45,
  includeNormalize: false,
  headerFontFamily: ["Montserrat", "sans-serif"],
  bodyFontFamily: ["Baloo 2", "sans-serif"],
  scaleRatio: 2.441,
  headerWeight: 700,
  googleFonts: [
    {
      name: "Montserrat",
      styles: ["700", "400"],
    },
    {
      name: "Baloo 2",
      styles: ["400"],
    },
  ],
  overrideStyles: () => ({
    img: {
      marginBottom: 0,
    },
  }),
});
*/

export default typography;



// WEBPACK FOOTER //
// ./config/typography.js